import { equals } from 'ramda';

import { type TCoordinate } from '@/packages/api-models/common/json_query';

export function coordsEqual(coords1: TCoordinate[], coords2: TCoordinate[]): boolean {
  return equals(coords1.concat().sort(), coords2.concat().sort());
}
